import moment from 'moment-timezone';

import styles from '../conditionFieldDate.module.scss';

export const maxDate = moment().add(1, 'day');

export const timePickerProps = {
  clearable: true,
  className: styles.timePicker,
};
